import React, {useState} from 'react';
import TextField from "@mui/material/TextField";
import {TextareaAutosize} from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Container from "@mui/material/Container";
import FormLabel from "@mui/material/FormLabel";
import {ref, get, child, set} from "firebase/database";
import {Trans} from "react-i18next";
import {useNavigate} from "react-router";

function TranslationEditor({db}) {
    const [path, setPath] = useState('');
    const [en, setEn] = useState('');
    const [ro, setRo] = useState('');
    const [hu, setHu] = useState('');
    const navigate = useNavigate();

    const dbRef = ref(db);
    const getData = () => {
        get(child(dbRef, `/translation/en/${path.replaceAll('.', '/')}`)).then((snapshot) => {
            if (snapshot.exists()) {
                setEn(snapshot.val());
            } else {
                setEn('');
            }
        }).catch((error) => {
            console.error(error);
        });
        get(child(dbRef, `/translation/ro/${path.replaceAll('.', '/')}`)).then((snapshot) => {
            if (snapshot.exists()) {
                setRo(snapshot.val());
            } else {
                setRo('');
            }
        }).catch((error) => {
            console.error(error);
        });
        get(child(dbRef, `/translation/hu/${path.replaceAll('.', '/')}`)).then((snapshot) => {
            if (snapshot.exists()) {
                setHu(snapshot.val());
            } else {
                setHu('');
            }
        }).catch((error) => {
            console.error(error);
        });
    }


    const setData = () => {
        if (path) {
            set(child(dbRef, `/translation/en/${path.replaceAll('.', '/')}`), en);
            set(child(dbRef, `/translation/ro/${path.replaceAll('.', '/')}`), ro);
            set(child(dbRef, `/translation/hu/${path.replaceAll('.', '/')}`), hu);
        }
    }


    return (
        <Container maxWidth="md" sx={{p: 6}}>
            <Button sx={{mt: 2}} color={'secondary'} onClick={() => navigate('/admin')}>&lt; <Trans i18nKey={'buttons.back'}/></Button>

            <Grid container>
                <Grid size={12} sx={{display: 'flex', flexDirection: 'column'}}>
                    <FormLabel htmlFor="email" required>
                        Path
                    </FormLabel>
                    <TextField
                        id="path"
                        name="Path"
                        type="text"
                        placeholder="Path"
                        size="small"
                        value={path}
                        onChange={(event) => setPath(event.target.value)}
                    />
                    <Button variant="contained" onClick={getData}>GET</Button>
                </Grid>
                <Grid size={12} sx={{display: 'flex', flexDirection: 'column', pt: 2}}>
                    <FormLabel htmlFor="email" required>
                        EN
                    </FormLabel>
                    <TextareaAutosize value={en} sx={{height: '100px'}}
                                      onChange={(event) => setEn(event.target.value)}/>
                </Grid>
                <Grid size={12} sx={{display: 'flex', flexDirection: 'column', pt: 2}}>
                    <FormLabel htmlFor="email" required>
                        RO
                    </FormLabel>
                    <TextareaAutosize value={ro} sx={{height: '100px'}}
                                      onChange={(event) => setRo(event.target.value)}/>
                </Grid>
                <Grid size={12} sx={{display: 'flex', flexDirection: 'column', pt: 2}}>
                    <FormLabel htmlFor="email" required>
                        HU
                    </FormLabel>
                    <TextareaAutosize value={hu} sx={{height: '100px'}}
                                      onChange={(event) => setHu(event.target.value)}/>
                </Grid>
                <Grid size={12} sx={{pt:4, position: 'fixed', left: '80%', top: '40%'}}>
                    <Button variant="contained" onClick={setData}>Submit</Button>
                </Grid>
            </Grid>
        </Container>
    );
}

export default TranslationEditor;
